import {create} from 'zustand';
import {AdditionalQuestionsErrorStore} from './types';

export const useAdditionalQuestionsErrorStore = create<AdditionalQuestionsErrorStore>(set => ({
	additionalQuestionsError: false,
	setAdditionalQuestionsError: value => set({additionalQuestionsError: value}),
	resetAdditionalQuestionsError: () => set({additionalQuestionsError: false}),
}));
